import { Button } from '@chikara/ui';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import * as ROUTES from '@/shared/constants/routes'
import styles from '../Onboarding.module.css';
import { t } from '@/i18n';


export function SuccessStep() {
	const navigate = useNavigate();
	const { isAuthenticated } = useAuth();

	const destination = isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN;

	return (
		<div className={styles.successContainer}>
			<h2 className={styles.title}>{t('onboarding.success.title')}</h2>
			<p className={styles.subtitle}>{t('onboarding.success.subtitle')}</p>

			<Button onClick={() => navigate(destination)} className={styles.submitButton}>
				{t('onboarding.success.action')}
			</Button>
		</div>
	);
}
